export default "__VITE_ASSET__CQkiJzQj__"